module.exports = __webpack_public_path__ + "static/media/ManageRequestGrey.0748f747.svg";